const OPENAI_ADS_PIXEL_ID = '2f8RjUe34mnuX3S9waqnj1';
const OPENAI_ADS_SDK_URL = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
const PRODUCTION_HOSTS = new Set(['meshum.com', 'www.meshum.com']);

export function isOpenAIAdsProductionHost(hostname) {
  return PRODUCTION_HOSTS.has(String(hostname || '').toLowerCase());
}

export function initializeOpenAIAdsPixel(windowObject = window, documentObject = document) {
  if (!isOpenAIAdsProductionHost(windowObject?.location?.hostname)) return false;
  if (windowObject.oaiq) return false;

  try {
    // OpenAI Ads Manager setup code. The production-host guard above keeps it
    // out of local, preview, staging, test, and prerender environments.
    // eslint-disable-next-line no-unused-expressions
    !function(w, d, s, u) {
      if (w.oaiq) return;
      var q = function() { q.q.push(arguments); };
      q.q = [];
      w.oaiq = q;
      var j = d.createElement(s);
      j.async = 1;
      j.src = u;
      var f = d.getElementsByTagName(s)[0];
      f.parentNode.insertBefore(j, f);
    }(windowObject, documentObject, 'script', OPENAI_ADS_SDK_URL);

    windowObject.oaiq('init', {
      pixelId: OPENAI_ADS_PIXEL_ID,
      debug: true,
    });
    return true;
  } catch {
    return false;
  }
}

export function measureOpenAIContentsViewed(windowObject = window) {
  if (!isOpenAIAdsProductionHost(windowObject?.location?.hostname)) return false;
  if (typeof windowObject.oaiq !== 'function') return false;

  try {
    windowObject.oaiq(
      'measure',
      'contents_viewed',
      { type: 'contents' }
    );
    return true;
  } catch {
    return false;
  }
}
